const PAYPAL_COMMISSION = 0.0275;

const salesItemCalculator = (salesItem) => {
  const item = {};

  item.name = salesItem.productName;

  item.numberSold = salesItem.openingStock - salesItem.closingStock - salesItem.numberFreebies;

  item.numberGifted = salesItem.numberFreebies;

  item.numberPaypal = salesItem.numberPaypal;

  item.totalRevenue = item.numberSold * salesItem.productPrice;

  item.paypalCommission = salesItem.numberPaypal * (salesItem.productPrice * PAYPAL_COMMISSION);
  
  item.netRevenue = item.totalRevenue - item.paypalCommission;

  const priorShares = [];
  const residueShares = [];

  salesItem.productRecipients
    .filter(recipient => recipient.type === "prior")
    .forEach(recipient => {
      priorShares.push({
        name: recipient.recipientName,
        share: item.numberSold * recipient.split
      });
    });

    const combinedPriorShares = priorShares.reduce((acc, share) => {
      return (acc + share.share);
    }, 0);

    salesItem.productRecipients
    .filter(recipient => recipient.type === "residue")
    .forEach(recipient => {
      residueShares.push({
        name: recipient.recipientName,
        share: (item.netRevenue - combinedPriorShares) * (recipient.split / 100)
      });
    });

    item.recipientShares = [...priorShares, ...residueShares];
  
  return item;
}

export default salesItemCalculator;